export function domainMatchesList(domain, includeDomains, excludeDomains = []) {
  const matchesTLD = entry => entry === '*' || entry === domain.tld;
  // Enabled if any entries in `includeDomains` match and no entries in
  // `excludeDomains` match (including wildcard matches for both).
  return includeDomains.some(matchesTLD) && !excludeDomains.some(matchesTLD);
}
